import React from 'react';
import './BackgroundDecoration.css';

const BackgroundDecoration = () => {
  return (
    <div className="background-decoration">
      <div className="floating-particle"></div>
      <div className="floating-particle"></div>
      <div className="floating-particle"></div>
      <div className="floating-particle"></div>
      <div className="floating-particle"></div>
    </div>
  );
};

export default BackgroundDecoration;

